import "../../styles/modal.css";
import { LuCircleX } from "react-icons/lu";

export default function ImageModal({
  imageSrc,
  imageAlt,
  onClose,
  visibility,
}) {
  return (
    <div className={`modal ${visibility}`} onClick={onClose}>
      <div
        className="modal__container"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <img src={imageSrc} alt={imageAlt} className="modal__image" />
        <button className="modal__action" onClick={onClose}>
          <LuCircleX />
        </button>
      </div>
    </div>
  );
}
